import React from 'react'

export default function ArrowUp() {
  return (
    <svg className="ArrowUp--svg" width={11} height={17}>
      <path
        d="M4.854 16.707V1.915L.708 6.061 0 5.353 5.353 0l5.355 5.353-.708.708-4.146-4.146v14.792z"
        fill="#2D3B45"
        fillRule="evenodd"
      />
    </svg>
  )
}
